import React from "react";
import { GlobalStyles } from "./src/styles/GlobalStyles";
import { MDXProvider } from "@mdx-js/react";
import {
  Blockquote,
  PrismWrapper,
  Headings,
  Code,
} from "./src/components/MDXComponents";

const components = {
  h2: Headings.myH2,
  h3: Headings.myH3,
  inlineCode: Code,
  blockquote: Blockquote,
  pre: PrismWrapper,
};

export const wrapMDX = ({ element }) => {
  return (
    <MDXProvider components={components}>
      <GlobalStyles />
      {element}
    </MDXProvider>
  );
};
